import React, { useEffect } from 'react';
import { t } from '@lingui/core/macro';

import TabbedNavigation from '@rover/components/src/navigation/TabbedNavigation/TabbedNavigation';
import { MOBILE_MAX_WIDTH_LAYOUT } from '@rover/constants/src/translations/sitterProfilePage.constants';
import { Box, Flex } from '@rover/kibble/core';

type Props = {
  showReviewsTab?: boolean;
};

const Tabs = ({ showReviewsTab }: Props): JSX.Element => {
  const tabs = [
    ...(showReviewsTab ? [{ label: t`Reviews`, url: '#reviews' }] : []),
    { label: t`Services & Calendar`, url: '#services' },
    { label: t`Details`, url: '#details' },
  ];

  useEffect(() => {
    if (process.env.JS_ENV_CLIENT) {
      const htmlElement = document.getElementsByTagName('html');
      htmlElement[0].style.scrollBehavior = 'smooth';
    }
    return () => {
      if (process.env.JS_ENV_CLIENT) {
        const htmlElement = document.getElementsByTagName('html');
        htmlElement[0].style.scrollBehavior = 'initial';
      }
    };
  }, []);

  return (
    <Flex
      width="100%"
      minWidth="initial"
      position="sticky"
      top="0"
      display={['flex', 'none']}
      background="primary"
      sx={{ overflowX: 'auto', oveflowY: 'hidden' }}
      data-testid="sitter-profile-tabs"
      flexDirection="column"
      alignItems="center"
      zIndex="999"
    >
      <Flex flexDirection="column" alignItems="center" width="100%">
        <Box width="100%" maxWidth={MOBILE_MAX_WIDTH_LAYOUT} zIndex="999">
          <TabbedNavigation
            tabs={tabs}
            highlightActiveTab={false}
            paddingTop="0x"
            paddingBottom="0x"
            sxTab={{
              flex: '1',
              display: 'flex',
              justifyContent: 'center',
              whiteSpace: 'nowrap',
              minWidth: 'initial',
            }}
            sxText={{ size: '200' }}
          />
        </Box>
        <Box
          width="100%"
          borderBottomWidth="2px"
          borderBottomStyle="solid"
          borderBottomColor="border.primary"
          sx={{ mt: '-2px' }}
          zIndex="998"
        />
      </Flex>
    </Flex>
  );
};

export default Tabs;
